export const getIsResetEnabled = ({
  canResetZoom,
  hiddenSeriesIds,
}: {
  canResetZoom: boolean;
  hiddenSeriesIds?: Set<string>;
}): boolean => {
  return canResetZoom || (hiddenSeriesIds?.size ?? 0) > 0;
};
